import React from 'react'
import MoreAboutThisWebsite from '../content/more-about-this-website.mdx'
import Dialog from './dialog'
import styled from 'styled-components'

const ReadMoreLink = styled.span`
  font-weight: 600;
  cursor: pointer;
`

interface IProps {}

interface IState {
  isOpen: boolean
}

const ConservationAreas = class extends React.Component<IProps, IState> {
  state = {
    isOpen: false
  }

  toggleOpen = (open: boolean) => {
    this.setState(() => ({
      isOpen: open
    }))
  }

  render() {
    const { isOpen } = this.state
    return (
      <>
        <ReadMoreLink onClick={() => this.toggleOpen(true)}>Read more</ReadMoreLink>
        <Dialog open={isOpen} setPopupState={this.toggleOpen} heading="More about the MSA Levy">
          <MoreAboutThisWebsite />
        </Dialog>
      </>
    )
  }
}

export default ConservationAreas
